import { Skeleton } from '@/components/shadcn/skeleton'
import { ChatContainer } from './Chat/ChatContainer'
import { ChatInput } from './Chat/ChatInput'
import { MessageList } from './Chat/MessageList'
import { useChat } from './Chat/hooks'
import { useGetAppSupportMenu } from './SupportPanel/useGetAppSupportMenu'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { Button } from '@/components/shadcn/button'
import { IconV2ArchiveOutline } from '@icons/IconV2ArchiveOutline'
import { IconV2LightbulbOutline } from '@icons/IconV2LightbulbOutline'
import { IconV2DocumentDraftOutline } from '@icons/IconV2DocumentDraftOutline'
import { IconV2DocumentDirectoryOutline } from '@icons/IconV2DocumentDirectoryOutline'

const IconMap = {
  'data-templates': IconV2DocumentDirectoryOutline,
  'data-assets': IconV2ArchiveOutline,
  glossary: IconV2DocumentDraftOutline,
  faq: IconV2LightbulbOutline,
}

const _supportPanelViews = ['small', 'expanded'] as const
const _supportPanelTypes = ['data-templates', 'data-assets', 'glossary', 'faq'] as const
export type SupportPanelSize = (typeof _supportPanelViews)[number]
export type SupportPanelType = (typeof _supportPanelTypes)[number]
export type SupportPanelView = { key: SupportPanelType; size: SupportPanelSize }

export function AppSupportMenu({
  setSupportPanelView,
  sidebarOpen,
}: {
  setSupportPanelView: React.Dispatch<React.SetStateAction<SupportPanelView | undefined>>
  sidebarOpen: boolean
}) {
  const { data: supportMenu } = useGetAppSupportMenu()
  // const scrollAreaRef = useRef<HTMLDivElement>(null)

  return (
    <div className="flex w-[calc(100%-7.5px)] flex-col items-start rounded-lg bg-muted px-2.5 py-2">
      <>
        {supportMenu.map((item) => {
          const Icon = item.key ? IconMap[item.key as keyof typeof IconMap] : null
          const buttonContent = (
            <Button
              variant="ghost"
              className="px-0"
              onClick={() => setSupportPanelView({ key: item.key as SupportPanelType, size: 'small' })}
            >
              {Icon && <Icon className="size-4" />}
              <span className={`${!sidebarOpen ? 'invisible' : ''}`}>{item.label}</span>
            </Button>
          )
          return (
            <TooltipButton key={item.key ?? item.label} tooltip={item.label} side="right" disabled={sidebarOpen}>
              {buttonContent}
            </TooltipButton>
          )
        })}
      </>
    </div>
  )
}

export function AppSupportMenuLoading() {
  return (
    <div className="w-[calc(100%-7.5px)] items-start rounded-lg bg-muted px-2.5 py-2">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-4 w-24" />
    </div>
  )
}

export function AppSupportMenuChat() {
  const { error } = useChat()

  return (
    <ChatContainer>
      {error && (
        <div className="border-b border-red-200 bg-red-50 p-3">
          <p className="text-sm text-red-600">Failed to send message. Please try again.</p>
        </div>
      )}

      {/* Messages */}
      <MessageList />

      {/* Input */}
      <ChatInput className="bg-offwhite/80 backdrop-blur" />
    </ChatContainer>
  )
}
